// Resolves the effective backend base URL at runtime.
//
// The frontend is built with a fixed REACT_APP_BACKEND_URL, but that host can
// legitimately be visited under two variants of the SAME site (e.g. the bare
// domain and its `www.` subdomain). Browsers treat those as different origins,
// which means a build baked to `https://certivsims.com.au` triggers CORS when
// the user visits `https://www.certivsims.com.au`.
//
// To avoid that class of failure, if the current page host is a plain
// www./bare-domain variant of the built host, we rewrite the base URL to the
// current origin so API calls stay same-origin. Any other host mismatch (e.g.
// completely different preview URL) falls back to the built value unchanged.

const stripWww = (h) => (h || "").replace(/^www\./i, "");

export function resolveBackendUrl() {
  const built = process.env.REACT_APP_BACKEND_URL || "";
  if (!built) return "";
  if (typeof window === "undefined" || !window.location) return built;
  try {
    const builtHost = new URL(built).hostname;
    const currentHost = window.location.hostname;
    if (!builtHost || !currentHost) return built;
    // Exact host match — nothing to rewrite.
    if (builtHost === currentHost) return built;
    // Only rewrite when the two differ ONLY by a `www.` prefix.
    // (e.g. built=certivsims.com.au, current=www.certivsims.com.au)
    if (stripWww(builtHost) === stripWww(currentHost)) {
      return window.location.origin;
    }
    return built;
  } catch {
    return built;
  }
}

export const BUILT_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
